import React from 'react';
import { motion } from 'framer-motion';
import { Map, TrendingUp, MessageSquare, Database } from 'lucide-react';
const services = [{
  title: 'Geospatial Intelligence',
  description: 'Use location intelligence to understand trade areas, competitor saturation, customer movement, and optimal expansion decisions.',
  icon: Map,
  color: 'text-blue-600',
  bg: 'bg-blue-50',
  border: 'border-blue-100'
}, {
  title: 'Market Expansion Strategy',
  description: 'Data-driven roadmaps for opening new locations or scaling demand for the one you already have. Minimize risk. Maximize upside.',
  icon: TrendingUp,
  color: 'text-[#ff8a33]',
  bg: 'bg-orange-50',
  border: 'border-orange-100'
}, {
  title: 'Review Acquisition Systems',
  description: 'Automated systems that consistently generate authentic 5-star Google reviews — boosting local SEO, trust, and booking conversion.',
  icon: MessageSquare,
  color: 'text-emerald-600',
  bg: 'bg-emerald-50',
  border: 'border-emerald-100'
}, {
  title: 'Funnel Infrastructure',
  description: 'Marketing funnels and follow-up systems that turn traffic and interest into booked appointments, walk-ins, or reservations with predictable ROI.',
  icon: Database,
  color: 'text-purple-600',
  bg: 'bg-purple-50',
  border: 'border-purple-100'
}];
export function HowIHelp() {
  return <section id="how-i-help" className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-185">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-gray-200 text-gray-600 text-xs font-semibold uppercase tracking-wider mb-6 shadow-sm" data-id="element-187">
            Capabilities
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-188">
            Strategic Growth for{' '}
            <span className="text-gradient-orange" data-id="element-189">
              Physical-Location Businesses
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-600" data-id="element-190">
            I bridge the gap between complex data and real, measurable outcomes.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-191">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-2xl p-8 shadow-xl shadow-gray-200/50 border border-gray-100 hover:border-gray-200 transition-all group" data-id="element-192">
              <div className={`w-14 h-14 rounded-xl ${service.bg} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-193">
                <service.icon className={`w-7 h-7 ${service.color}`} data-id="element-194" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-195">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-196">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}